module.exports = __webpack_public_path__ + "static/media/footer.2c22418c.png";